import React, { useState } from 'react';

function SupplierLogo({ supplier, logoPath }) {
  const [logoError, setLogoError] = useState(false);

  return (
    <div className="avionics-logo-item">
      {logoError ? (
        <div className="avionics-logo-placeholder">
          <span className="logo-text-small">{supplier}</span>
        </div>
      ) : (
        <img
          src={logoPath}
          alt={`${supplier} logo`}
          className="avionics-logo"
          onError={() => setLogoError(true)}
        />
      )}
    </div>
  );
}

function AvionicsCard({ supplier, logoPath, suppliers, stats = {} }) {
  // Support both single supplier and multiple suppliers
  const supplierList = suppliers || [{ name: supplier, logoPath }];
  const supplierNames = supplierList.map(s => s.name).join(', ');

  // Determine container class: use grid for 3+ suppliers, flex for 2
  const containerClass = supplierList.length >= 3
    ? 'avionics-logo-container-grid'
    : supplierList.length === 2
      ? 'avionics-logo-container-multi'
      : '';

  return (
    <div className="avionics-card">
      <div className={`avionics-logo-container ${containerClass}`}>
        {supplierList.map((sup, index) => (
          <SupplierLogo
            key={index}
            supplier={sup.name}
            logoPath={sup.logoPath}
          />
        ))}
      </div>

      <div className="avionics-stats">
        <div className="stat-item">
          <span className="stat-label">Primary Avionics Supplier{supplierList.length > 1 ? 's' : ''}</span>
          <span className="stat-value">{supplierNames}</span>
        </div>

        {/* Render additional stats if provided */}
        {Object.entries(stats).map(([key, value]) => (
          <div key={key} className="stat-item">
            <span className="stat-label">{key}</span>
            <span className="stat-value">{value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AvionicsCard;
